module.exports = __webpack_public_path__ + "static/media/logo.251bf5c8.svg";